import { default as CookieBanner } from './cookie-banner-wrapper'

export default CookieBanner
